import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewFullServiceDetails: {
		id: 'issue-field-service-entity.header-content.view-full-service-details',
		defaultMessage: 'View full service details',
		description: 'Button to open a dialog containing complete details about the service',
	},
	deleteService: {
		id: 'issue-field-service-entity.header-content.delete-service',
		defaultMessage: 'Remove service',
		description: 'Label for button to delete a service',
	},
	ariaLabel: {
		id: 'issue-field-service-entity.header-content.aria-label',
		defaultMessage: 'View full service details in a new window',
		description: 'Aria label for opening service details',
	},
});
